export default "__VITE_ASSET__9Tc$I_S8__"